import { type Preselect } from "./home-standing";
import { uuidParam } from "./search-params";

/**
 * The request-a-test handoff, `?facility=<uuid>&devices=<uuid>,<uuid>`: the
 * property the wizard opens on and the devices chosen there, most urgent first.
 * `devices` is one comma-joined value so the list reads as one parameter.
 */
export interface RequestTestSearch {
  facility?: string;
  devices?: string;
}

function isUuid(value: unknown): value is string {
  return uuidParam(value) !== undefined;
}

// A value that cannot be an id is dropped rather than carried into the wizard,
// and a device list means nothing without the property it was chosen at.
export function validateRequestTestSearch(search: Record<string, unknown>): RequestTestSearch {
  if (!isUuid(search.facility)) return {};
  const devices =
    typeof search.devices === "string"
      ? [...new Set(search.devices.split(",").filter(isUuid))]
      : [];
  return devices.length > 0
    ? { facility: search.facility, devices: devices.join(",") }
    : { facility: search.facility };
}

export function requestTestSearch(preselect: Preselect | null): RequestTestSearch {
  if (!preselect) return {};
  return preselect.installationIds.length > 0
    ? { facility: preselect.facilityId, devices: preselect.installationIds.join(",") }
    : { facility: preselect.facilityId };
}

export function selectedDeviceIds(search: RequestTestSearch): string[] {
  return search.devices ? search.devices.split(",").filter((id) => id.length > 0) : [];
}
